window.ROSCHAT_WEB_BUILD_ENV = {
    VERSION: '5.2-1868'
};